<template>
  <!-- transfer details -->
  <div class="transfer_details">
    <!-- transfer basic details -->
    <div class="basic__info">
      <!-- incoming transfer id -->
      <div class="transfer_id mt-5 text-4xl font-semibold text-center text-black w-full">Incoming Transfer from {{ form.transferFrom && form.transferFrom.business_name }}</div>

      <!-- transfer created -->
      <div class="transfer_id mt-2 text-lg text-center w-full">Created {{ formatDateTime(new Date()) }} by {{ transferCreatedBy && transferCreatedBy.business_name }}</div>

      <hr class="my-3" />

      <!-- transfer sources -->
      <div class="grid grid-cols-2">
        <!-- transfer from -->
        <div class="border-0 border-r-2 border-solid px-20 relative">
          <div class="transfer_from">
            <p class="text-lg font-bold mb-3">Transfer From</p>

            <!-- transfer from details -->
            <div v-if="form.transferFrom">
              <p>{{ form.transferFrom.business_name }}</p>
              <p>Lic# {{ form.transferFrom.license_number }}</p>
              <p>{{ form.transferFrom.mobile }}</p>
              <p>{{ form.transferFrom.address }}</p>
              <p>{{ form.transferFrom.city && form.transferFrom.city.city_name + ', ' }} {{ form.transferFrom.state }} {{ form.transferFrom.postcode }}</p>
            </div>
          </div>

          <div class="invoice-arrow">
            <feather-icon icon="ArrowRightIcon" />
          </div>
        </div>

        <!-- transfer to -->
        <div class="px-20">
          <div class="transfer_from">
            <p class="text-lg font-bold mb-3">Transfer To</p>

            <div v-if="form.transferTo">
              <p>{{ form.transferTo.business_name }}</p>
              <p>Lic# {{ form.transferTo.omma_license_number }}</p>
              <p>{{ form.transferTo.mobile }}</p>
              <p>{{ form.transferTo.address }}</p>
              <p>{{ form.transferTo.city && form.transferTo.city.city_name + ', ' }} {{ form.transferTo.state }} {{ form.transferTo.postcode }}</p>
            </div>
          </div>
        </div>
      </div>

      <hr class="my-3" />
    </div>

    <!-- transfer items -->
    <h4 class="mt-5">Transfer Items</h4>

    <transfer-items
      ref="transferItem"
      :products="item"
      :productCategories="productCategories"
      :itemOptions.sync="itemOptions"
      @addNewItem="addNewItemModal(i)"
      @delete_package="deletePackage(i)"
      v-for="(item, i) in totalPackages"
      :key="i"
    />

    <!-- add package btn -->
    <div class="mt-5">
      <div class="add_package_btn">
        <vs-button class="mr-2 vs-con-loading__container" id="add-product-button" @click="addNewProduct" type="filled">
          Add Product <feather-icon icon="PlusIcon" svgClasses="h-4 w-4 ml-2" />
        </vs-button>
      </div>
    </div>

    <!-- transfer summary -->
    <div class="transfer_summary mt-5 flex justify-between">
      <div class="total_packages">
        <p class="font-bold text-base">Total Transfer Items</p>
        <p class="text-3xl font-black">{{ totalPackages.length }} Products</p>
      </div>

      <div class="total_const">
        <vx-tooltip class="flex-none mt-3" text="The total price you paid for this product.">
          <p class="font-bold text-base" color="danger" icon-pack="feather" icon="icon-trash-2">Total</p>
        </vx-tooltip>
        <div class="mt-auto ml-2"></div>
        <p class="text-3xl font-black">${{ transferDollars }}</p>
      </div>
    </div>

    <hr class="my-3" />

    <div class="action_btn text-center">
      <vs-button class="mr-2 vs-con-loading__container" id="add-product-button" @click="saveTransfer" type="relief">Save</vs-button>
      <vs-button color="danger" type="relief" class="text-left" @click="$router.push({ name: 'transfer-list' })">Cancel</vs-button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import { dateMixins } from '@/mixins/dateMixins.js'
import Select2 from '@/components/custom/form-elements/Select2.vue'
import TransferItems from '@/views/transfers/components/AddTransferItem.vue'
import { DEMORETAILER } from '@/utils/roles.js'
import { getRandomString } from '@/utils/functions'

export default {
  name: 'TransferDetails',

  components: {
    Select2,
    TransferItems
  },

  data() {
    return {
      DEMORETAILER,
      length: 0,
      page: 1,
      search: '',
      order: [],
      itemList: [],
      selectedTransferItem: null,
      productCategories: [],
      form: {
        transferFrom: null,
        transferTo: null,
        transfer_no: null,
        created_at: null
      },
      tranStatus: 'pending',
      transferCreatedBy: null,
      totalPackages: [],
      loading: false
    }
  },

  // mixins
  mixins: [dateMixins],

  // mounted prop
  async mounted() {
    const transferId = this.$route.query.id
    const tData = this.$route.query

    if (!transferId) {
      if (tData.supplier_type !== 'user') {
        // fetch supplier detail
        this.$store
          .dispatch('supplier/get', tData.supplierId)
          .then((res) => {
            this.form.transferFrom = res.data.supplier
          })
          .catch((err) => {
            const { message } = err
            this.$vs.notify({
              title: 'Error',
              text: message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          })
      } else {
        this.form.transferFrom = this.user
      }

      this.form.transfer_no = getRandomString('tr')
      this.form.transferTo = this.parentUser
      this.transferCreatedBy = this.user
    }

    // transfer
    if (transferId) {
      this.$store
        .dispatch('transfer/getTransferById', transferId)
        .then((res) => {
          const tData = res.data.transfer

          this.form.transfer_no = tData.transfer_no
          this.form.transferFrom = tData.transferFrom
          this.form.transferTo = tData.transferTo
          this.form.created_at = tData.created_at
          this.transferCreatedBy = tData.user
          this.tranStatus = tData.transfer_status
          this.totalPackages = tData.transferPackage
        })
        .catch((err) => {
          const { message } = err
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    }

    this.getProductCategories()

    this.addNewProduct()
  },

  computed: {
    ...mapState('product', { products: 'products', total: 'total', FilteredCount: 'FilteredCount', categories: 'categories' }),
    ...mapState('auth', ['parentUser', 'user']),

    itemOptions() {
      return this.products.reduce((acc, product) => {
        acc.push({ label: product.name, value: product.id })

        return acc
      }, this.itemList)
    },

    // calculate total transfer dollar
    transferDollars() {
      return this.totalPackages.reduce((acc, product) => {
        acc +=
          Number(product.purchase_price) * Number(product.categoryId === this.categories.FLOWER || product.categoryId === this.categories.SHAKE ? product.weight_per_package : product.quantity) || 0
        return acc
      }, 0)
    }
  },

  methods: {
    ...mapActions('product', { getAllProductCategories: 'getAllProductCategories' }),
    ...mapActions('transfer', { addTransfer: 'addTransfer' }),
    ...mapMutations('product', ['SET_STATE']),

    // get all product categories
    async getProductCategories() {
      const res = await this.getAllProductCategories({
        is_global: this.user.roleId === DEMORETAILER ? null : 'global',
        is_status: true
      })

      this.productCategories = res.data
    },

    // add new package
    addNewProduct() {
      const tempPackageObj = {
        categoryId: null,
        batch: null,
        product_name: null,
        sales_price: null,
        weight_type: null,
        weight_per_package: null,
        quantity: null,
        purchase_price: null,
        thc: null,
        cbd: null,
        terpenoid_potency: null,
        plant_stage: null,
        batchPlantIds: []
      }
      this.totalPackages.push(tempPackageObj)
    },

    // remove package
    deletePackage(i) {
      this.totalPackages.splice(i, 1)
    },

    async saveTransfer() {
      this.loading = true
      if (this.totalPackages) {
        //validate all ingredient details to
        const checkTransporter = (await Promise.all(this.$refs['transferItem'].map((child) => child.$validator.validate()))).filter((bool) => !bool).length === 0
        if (!checkTransporter) {
          this.$vs.notify({
            title: 'Error',
            text: 'please fill the form first',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })

          this.loading = false

          return
        }

        const checkQuntity = this.totalPackages.find((x) => ([this.categories.FLOWER, this.categories.SHAKE].includes(x.categoryId) ? x.weight_per_package === 0 : x.quantity === 0))
        if (checkQuntity) {
          this.$vs.notify({
            title: 'Error',
            text: 'please add quantity',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })

          this.loading = false

          return
        }
      }

      // add transfer
      this.$store
        .dispatch('transfer/addTransfer', {
          ...this.form,
          supplierId: Number(this.$route.query.supplierId),
          transporterId: Number(this.$route.query.transporterId),
          totalDollar: this.transferDollars,
          products: this.totalPackages,
          supplier_type: this.$route.query.supplier_type
        })
        .then(() => {
          this.$router.push('/transfer/list')
          this.loading = false
          this.$vs.notify({
            title: 'Success',
            text: 'Transfer updated successfully!',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
        })
        .catch((err) => {
          const { message } = err
          this.loading = false
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },

    updateItemList(data) {
      this.totalPackages[this.selectedTransferItem].itemId = data.id
      this.$nextTick(() => {
        this.getData()
      })
    }
  },

  watch: {
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '.transfer_details',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('.transfer_details > .con-vs-loading')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.transfer_details {
  .transfer__status {
    &.pending {
      background: #000;
    }

    &.approved {
      background: rgb(40, 199, 111);
    }
  }
}

.invoice-arrow {
  position: absolute;
  top: 50%;
  right: 0;
  width: 1.6rem;
  height: 1.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  transform: translate(50%, -50%);
  background-color: #fff;
  span {
    width: 90%;
    height: 90%;
  }
}
</style>
